export default __webpack_public_path__ + "static/media/ic-checklist-circle-green.33e253c3.svg";